<template>
  <a-cascader
    v-model:value="value"
    :options="options"
    change-on-select
    expand-trigger="hover"
    placeholder="请选择部门"
    :field-names="{
      label: 'structureName',
      value: 'id',
      children: 'children',
    }"
    @change="selectSuperiorDepartment"
  />
</template>

<script>
import { defineComponent, nextTick, reactive, ref, watch, inject } from "vue";

export default defineComponent({
  props: {
    echoVal: Number,
    clear: Boolean,
  },
  setup(props, context) {
    const value = ref([]);
    const options = inject("structureData", []);
    const selectSuperiorDepartment = (values, selectedOptions) => {
      const pid =
        value.value.length === 0 ? null : value.value[value.value.length - 1];
      context.emit("selectSuperiorDepartment", pid, selectedOptions);
    };

    const findStructure = (id) => {
      const structrueList = [];

      const flatten = (list) => {
        list.forEach((item) => {
          structrueList.push({
            structureName: item.structureName,
            id: item.id,
            pid: item.pid,
          });

          if (item.children && item.children.length > 0) {
            flatten(item.children);
          }
        });
      };

      flatten(options);

      const searchval = [];

      const searchstructure = (id) => {
        const find = structrueList.find((f) => f.id === id);
        searchval.push(find.id);
        if (find.pid !== 0) {
          searchstructure(find.pid);
        }

        if (find.pid === 0) return;
      };
      searchstructure(id);
      value.value.length = 0;
      value.value.push(...searchval.reverse());
    };

    watch(
      () => props.echoVal,
      (val) => {
        if (val) {
          findStructure(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.clear,
      (val) => {
        if (!val) {
          value.value.length = 0;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return { value, options, selectSuperiorDepartment };
  },
});
</script>

<style lang="less" scoped>
</style>
